export default __webpack_public_path__ + "static/media/Paypal_Login.8c527612.png";